import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener('change', () => {
      let buttonId = 'submit-on-change--submit-button',
        form = !!this.element.dataset.elementTarget ? document.querySelector(this.element.dataset.elementTarget) : this.element.closest('form');

      form.insertAdjacentHTML('beforeEnd', `<button class="d-none" id="${buttonId}">`);
      form.querySelector(`#${buttonId}`).click();
    });
  }
};